import LegalPage from "../components/LegalPage";
import { CONTACT_EMAIL } from "../data/content";

export default function PrivacyPage() {
  return (
    <LegalPage
      testid="privacy-page"
      title="Privacy Policy"
      updated="July 2026"
      seoTitle="Privacy Policy | The Jamoon"
      seoDescription="How The Jamoon collects, uses and protects the information you share with us when you enquire about a stay or subscribe to our field notes."
      intro="The Jamoon is a small, family-run wilderness lodge, and we treat your information the way we treat our forest — lightly, and with care. This policy explains what we collect, why, and the choices you have."
      sections={[
        {
          heading: "What we collect",
          body: "We only collect what we need to answer you and arrange your stay:",
          items: [
            "Enquiry form: your name, email, phone number and your message.",
            "Newsletter: your email address, if you choose to subscribe.",
            "Basic, non-identifying usage information your browser sends to any website.",
          ],
        },
        {
          heading: "How we use it",
          body: "Your details are used to reply to your enquiry, to plan and confirm a stay, and — only if you have subscribed — to send occasional field notes from the forest. We never sell or rent your information to anyone.",
        },
        {
          heading: "Email and trusted services",
          body: "Enquiries are delivered to our lodge inbox through Resend, an email delivery service, and stored securely in our own database. We share your information only with the services strictly needed to operate this site, and only to the extent required.",
        },
        {
          heading: "Cookies and local storage",
          body: "We keep things minimal. The site stores a single preference in your browser — whether the dawn-chorus ambient sound is on or off. We do not run advertising trackers or sell behavioural data.",
        },
        {
          heading: "Your choices and rights",
          items: [
            "Unsubscribe from field notes at any time.",
            "Ask us to access, correct or delete the information we hold about you.",
            "To exercise any of these, simply write to " + CONTACT_EMAIL + ".",
          ],
        },
        {
          heading: "Children",
          body: "This site is intended for adults planning travel and is not directed at children under 13.",
        },
        {
          heading: "Changes and contact",
          body: "We may update this policy from time to time; the date above reflects the latest version. Any questions about your privacy can be sent to " + CONTACT_EMAIL + ".",
        },
      ]}
    />
  );
}
